module.exports = __webpack_public_path__ + "static/sf_7.797067ee.png";